module.exports = __webpack_public_path__ + "images/emoji/couplekiss.44cccd5ea668a6ef6774.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/couplekiss.png
// module id = O15u
// module chunks = 14